// Filas de saaservices GET /abaco/controltj (AbacoDAO.getControlTjs): una por
// fecha + PDV (agencia-subagencia) + terminal + juego.

export const getTerminal = (item) =>
  item.terminal ?? item.codigoMaquina ?? item.maquina ?? "-";

const subagencyOf = (pdv) => Number(String(pdv).split("-")[1]) || 0;

// Agrupa por PDV + terminal: con agencia concentradora dos subagencias pueden
// tener la misma terminal. Ordena por subagencia y terminal; dentro de cada
// grupo respeta el orden del backend (fecha, juego).
export const groupByPdvTerminal = (rows) => {
  const groups = new Map();
  (rows || []).forEach((item) => {
    const pdv = item.puntoDeVenta ?? "-";
    const terminal = getTerminal(item);
    const key = `${pdv}|${terminal}`;
    if (!groups.has(key)) groups.set(key, { key, pdv, terminal, rows: [] });
    groups.get(key).rows.push(item);
  });
  return [...groups.values()].sort(
    (a, b) =>
      subagencyOf(a.pdv) - subagencyOf(b.pdv) ||
      (Number(a.terminal) || 0) - (Number(b.terminal) || 0),
  );
};

export const sumField = (rows, field) =>
  (rows || []).reduce((acc, r) => acc + (Number(r[field]) || 0), 0);
